<nav aria-label="Main menu" class="dashboard-nav">
  <app-dashboard-nav-list [items]="dashboardItems" (itemClick)="itemClick.emit($event)" />
</nav>
